<div class="container py-4">
  <h4>Meeting ausw&auml;hlen</h4>
  <p class="text-muted">W&auml;hle das Meeting aus, dessen Fragen &amp; Antworten du betreuen m&ouml;chtest. Es kann immer nur ein Meeting gleichzeitig beobachtet werden - die Auswahl eines anderen Meetings beendet die bisherige Beobachtung automatisch. Vergangene Meetings k&ouml;nnen ebenfalls ausgew&auml;hlt werden, um bereits gestellte Fragen einzusehen.</p>

  <div *ngIf="isLoading">L&auml;dt Meetings...</div>

  <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    {{errorMessage}}
  </div>

  <table class="table table-striped" *ngIf="!isLoading">
    <thead>
      <tr>
        <th>Meeting</th>
        <th>Live-Teilnehmer</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let meeting of meetings">
        <td>
          {{meeting.name}}
          <span class="text-muted small" *ngIf="meeting.name !== meeting.scoId"> ({{meeting.scoId}})</span>
        </td>
        <td>{{meeting.liveParticipantCount != null ? meeting.liveParticipantCount : '-'}}</td>
        <td class="text-end">
          <button
            type="button"
            class="btn btn-sm"
            [class.btn-success]="isWatching(meeting)"
            [class.btn-outline-primary]="!isWatching(meeting)"
            [disabled]="busyScoId === meeting.scoId"
            (click)="watch(meeting)"
          >
            {{isWatching(meeting) ? 'Weiter beobachten' : 'Beobachten'}}
          </button>
        </td>
      </tr>
      <tr *ngIf="meetings.length === 0">
        <td colspan="3">Keine Meetings gefunden.</td>
      </tr>
    </tbody>
  </table>
</div>
